var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.onlyFile
      ? _c("div", { staticClass: "simple-form flex col-2" }, [
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.invoiceVoucher.contractNo))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.invoiceVoucher.issuerRealName || ""))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.invoiceVoucher.receiverRealComName))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.invoiceVoucher.receiverRealComCode))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(4),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.invoiceVoucher.receiverBankName))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(5),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.invoiceVoucher.receiverAcctNo))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(6),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.invoiceVoucher.invoiceTypeText))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(7),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.invoiceVoucher.invoiceSubjectTypeText))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(8),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.invoiceVoucher.invoiceTitle))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(9),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.invoiceVoucher.receiverTaxPayerNo))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(10),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [
                _vm._v(
                  _vm._s(parseFloat(_vm.invoiceVoucher.amount || 0).toFixed(2))
                )
              ]),
              _vm._v(" "),
              _c("span", [_vm._v("(元)")])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(11),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("div", { staticClass: "value" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.invoiceIssueMethodMap[
                        _vm.invoiceVoucher.issueMethod
                      ] || ""
                    )
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(12),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.invoiceVoucher.issuerAddrTel || ""))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(13),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.invoiceVoucher.receiverContactName))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(14),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.invoiceVoucher.receiverContactTel))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(15),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("div", { staticClass: "value" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.invoiceCollaboStateMap[
                        _vm.invoiceVoucher.collaboState
                      ] || ""
                    )
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(16),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.invoiceVoucher.actualNo))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(17),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("div", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.invoiceVoucher.actualCode))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(18),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("div", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.invoiceVoucher.creatorRealName || ""))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(19),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("div", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.invoiceVoucher.creatorStaffName || ""))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(20),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("div", { staticClass: "value" }, [
                _vm._v(
                  _vm._s(
                    _vm.invoiceCreateRoleMap[_vm.invoiceVoucher.creatorRole] ||
                      ""
                  )
                )
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "simple-form" }, [
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(21),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _vm.invoiceVoucher.fileUuid != null &&
          _vm.invoiceVoucher.fileUuid != ""
            ? _c(
                "div",
                { staticClass: "file-area clearfix" },
                [
                  _c("swb-file-item", {
                    attrs: {
                      fileName: _vm.invoiceVoucher.fileExtName,
                      fileUuid: _vm.invoiceVoucher.fileUuid,
                      fileBrowseUrl: _vm.invoiceVoucher.fileBrowseUrl,
                      fileDownloadUrl: _vm.invoiceVoucher.fileBrowseUrl,
                      deletable: false
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("合同编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("开票方名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("受票方公司名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("受票方公司编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("受票方银行名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("受票方银行账号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发票类型")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发票主体类型")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发票抬头")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("受票方纳税识别号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请发票金额")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "form-label", staticStyle: { width: "145px" } },
      [_c("label", [_vm._v("发票方式：")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("开票方地址电话")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("受票方联系人姓名")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("受票方联系电话")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "form-label", staticStyle: { width: "145px" } },
      [_c("label", [_vm._v("发票协同状态：")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发票号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "form-label", staticStyle: { width: "145px" } },
      [_c("label", [_vm._v("发票代码：")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "form-label", staticStyle: { width: "145px" } },
      [_c("label", [_vm._v("创建集团名称：")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "form-label", staticStyle: { width: "145px" } },
      [_c("label", [_vm._v("创建人名称：")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "form-label", staticStyle: { width: "145px" } },
      [_c("label", [_vm._v("创建方：")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("附件信息")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68944510", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68944510","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/invoiceVoucher/InvoiceVoucherInfo.vue
// module id = 2723
// module chunks = 0